define("checkout/components/seamless-checkout-table/line-item-section", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr data-test-id={{@testId}}>
    <td class="u--p__t {{concat 'qa--checkout__summary--' @id 'Text'}}">
      <span class="u--text--bold {{@titleQaClass}}">{{@title}}</span>
      {{#if @subtitle}}
        <br />
        <span class="u--text--light">
          {{@subtitle}}
        </span>
      {{/if}}
    </td>
    <td></td>
    {{#if @cost}}
      <td class="u--text--right {{concat 'qa--checkout__summary--' @id 'Price'}}" data-test-id={{concat @testId "-cost"}}>
        {{@cost}}
      </td>
    {{/if}}
  </tr>
  
  {{yield}}
  */
  {
    "id": "KL4R7CB2",
    "block": "[[[10,\"tr\"],[15,\"data-test-id\",[30,1]],[12],[1,\"\\n  \"],[10,\"td\"],[15,0,[29,[\"u--p__t \",[28,[37,0],[\"qa--checkout__summary--\",[30,2],\"Text\"],null]]]],[12],[1,\"\\n    \"],[10,1],[15,0,[29,[\"u--text--bold \",[30,3]]]],[12],[1,[30,4]],[13],[1,\"\\n\"],[41,[30,5],[[[1,\"      \"],[10,\"br\"],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[30,5]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[13],[1,\"\\n\"],[41,[30,6],[[[1,\"    \"],[10,\"td\"],[15,0,[29,[\"u--text--right \",[28,[37,0],[\"qa--checkout__summary--\",[30,2],\"Price\"],null]]]],[15,\"data-test-id\",[28,[37,0],[[30,1],\"-cost\"],null]],[12],[1,\"\\n      \"],[1,[30,6]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[18,7,null]],[\"@testId\",\"@id\",\"@titleQaClass\",\"@title\",\"@subtitle\",\"@cost\",\"&default\"],false,[\"concat\",\"if\",\"yield\"]]",
    "moduleName": "checkout/components/seamless-checkout-table/line-item-section.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});